// ✅ AMÉLIORATION 5 : Onglet Options avec hébergement simplifié - VERSION COMPLÈTE
import React from 'react';

const OptionsTab = ({
  formData,
  setFormData,
  errors = {},
  multiDayInfo = { days: [], totalDays: 0 },
  handleChange,
  statuses = [],
  editingSession
}) => {
  console.log('🎯 OptionsTab OPTIMISÉ - Hébergement simplifié');

  // ✅ Gestion du changement d'hébergement
  const handleAccommodationChange = (value) => {
    setFormData(prev => ({
      ...prev,
      accommodation_type: value
    }));
  };

  // ✅ Options d'hébergement simplifiées selon demande
  const accommodationOptions = [
    {
      value: 'none',
      label: 'Pas d\'hébergement',
      description: 'Les participants rentrent chez eux chaque soir',
      icon: '🏠',
      color: '#6c757d'
    },
    {
      value: 'all_nights',
      label: 'Hébergement toutes les nuits',
      description: 'Participants restent sur place pendant toute la formation',
      icon: '🏨',
      color: '#007bff'
    },
    {
      value: 'except_last_night',
      label: 'Hébergement sauf dernière nuit',
      description: 'Participants rentrent chez eux le dernier jour',
      icon: '🛏️',
      color: '#28a745'
    }
  ];

  // ✅ Calcul des nuits d'hébergement
  const calculateNights = () => {
    const totalDays = multiDayInfo.totalDays || 1;
    
    switch (formData.accommodation_type) {
      case 'all_nights':
        return Math.max(0, totalDays - 1); // n-1 nuits pour n jours
      case 'except_last_night':
        return Math.max(0, totalDays - 2); // n-2 nuits pour n jours
      case 'none':
      default:
        return 0;
    }
  };

  const nights = calculateNights();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {/* En-tête */}
      <div>
        <h3 style={{ 
          margin: '0 0 8px 0', 
          fontSize: '18px', 
          fontWeight: '600',
          color: '#495057'
        }}>
          Options de service
        </h3>
        <p style={{ 
          margin: 0, 
          fontSize: '14px', 
          color: '#6c757d' 
        }}>
          Configurez les services liés à la formation
        </p>
      </div>

      {/* ✅ CORRECTION : Options de service - Case-croûte ajoutée */}
      {(formData.prestation_type === 'prestation' || formData.session_type === 'training') && (
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '12px',
          border: '2px solid #e9ecef'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '16px'
          }}>
            <span style={{ fontSize: '24px' }}>🍽️</span>
            <div>
              <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                Services formation
              </h4>
              <p style={{ margin: 0, fontSize: '14px', color: '#6c757d' }}>
                Options logistiques pour les participants
              </p>
            </div>
          </div>

          {/* Case-croûte avec le nouveau design */}
          <label style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            padding: '16px',
            background: formData.needs_lunch ? '#e7f3ff' : 'white',
            border: `2px solid ${formData.needs_lunch ? '#007bff' : '#dee2e6'}`,
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}>
            <input
              type="checkbox"
              name="needs_lunch"
              checked={formData.needs_lunch || false}
              onChange={handleChange}
              style={{ marginTop: '2px' }}
            />
            
            <div style={{ flex: 1 }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '4px'
              }}>
                <span style={{ fontSize: '18px' }}>🍽️</span>
                <span style={{ 
                  fontWeight: '600',
                  fontSize: '14px',
                  color: formData.needs_lunch ? '#007bff' : '#495057'
                }}>
                  Repas à prévoir
                </span>
              </div>
              
              <p style={{
                margin: 0,
                fontSize: '13px',
                color: '#6c757d',
                lineHeight: '1.4'
              }}>
                Organiser les repas des participants pendant la formation
              </p>
            </div>
          </label>
        </div>
      )}

      {/* ✅ AMÉLIORATION 5 : Hébergement simplifié (SAC supprimé) */}
      {(formData.prestation_type === 'prestation' || formData.session_type === 'training') && (
        <div style={{
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '12px',
          border: '2px solid #e9ecef'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '16px'
          }}>
            <span style={{ fontSize: '24px' }}>🏨</span>
            <div>
              <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                Hébergement
              </h4>
              <p style={{ margin: 0, fontSize: '14px', color: '#6c757d' }}>
                Gestion de l'hébergement des participants
              </p>
            </div>
          </div>

          {/* Options d'hébergement */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {accommodationOptions.map(option => (
              <label
                key={option.value}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  padding: '16px',
                  background: formData.accommodation_type === option.value ? '#e7f3ff' : 'white',
                  border: `2px solid ${formData.accommodation_type === option.value ? option.color : '#dee2e6'}`,
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                <input
                  type="radio"
                  name="accommodation_type"
                  value={option.value}
                  checked={formData.accommodation_type === option.value}
                  onChange={(e) => handleAccommodationChange(e.target.value)}
                  style={{ marginTop: '2px' }}
                />
                
                <div style={{ flex: 1 }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '4px'
                  }}>
                    <span style={{ fontSize: '18px' }}>{option.icon}</span>
                    <span style={{ 
                      fontWeight: '600',
                      fontSize: '14px',
                      color: formData.accommodation_type === option.value ? option.color : '#495057'
                    }}>
                      {option.label}
                    </span>
                  </div>
                  
                  <p style={{
                    margin: 0,
                    fontSize: '13px',
                    color: '#6c757d',
                    lineHeight: '1.4'
                  }}>
                    {option.description}
                  </p>
                </div>
              </label>
            ))}
          </div>

          {/* Résumé hébergement (si multi-jours et hébergement sélectionné) */}
          {multiDayInfo.totalDays > 1 && formData.accommodation_type !== 'none' && (
            <div style={{
              marginTop: '16px',
              padding: '12px 16px',
              background: '#e8f5e8',
              border: '1px solid #c3e6c3',
              borderRadius: '8px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#155724'
              }}>
                <span>📊</span>
                <span>Résumé hébergement</span>
              </div>
              
              <div style={{
                fontSize: '13px',
                color: '#155724',
                marginTop: '4px'
              }}>
                Formation de <strong>{multiDayInfo.totalDays} jours</strong> → 
                <strong> {nights} nuit{nights > 1 ? 's' : ''}</strong> d'hébergement
                {formData.accommodation_type === 'except_last_night' && nights >= 0 && (
                  <span> (retour le dernier jour)</span>
                )}
              </div>
            </div>
          )}

          {/* Message d'information pour formation 1 jour */}
          {multiDayInfo.totalDays <= 1 && formData.accommodation_type !== 'none' && (
            <div style={{
              marginTop: '16px',
              padding: '12px 16px',
              background: '#fff3cd',
              border: '1px solid #ffeaa7',
              borderRadius: '8px'
            }}>
              <div style={{
                fontSize: '13px',
                color: '#856404',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span>💡</span>
                <span>Formation d'une seule journée : aucune nuit d'hébergement nécessaire</span>
              </div>
            </div>
          )}

          {/* Erreur de validation */}
          {errors.accommodation_type && (
            <div style={{
              marginTop: '8px',
              padding: '8px 12px',
              background: '#f8d7da',
              border: '1px solid #f5c6cb',
              borderRadius: '4px',
              fontSize: '13px',
              color: '#721c24'
            }}>
              {errors.accommodation_type}
            </div>
          )}
        </div>
      )}

      {/* Debug information (à supprimer en production) */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{
          background: '#fff3cd',
          padding: '12px',
          borderRadius: '6px',
          fontSize: '12px',
          color: '#856404'
        }}>
          <strong>Debug OptionsTab:</strong><br/>
          accommodation_type: {formData.accommodation_type || 'none'}<br/>
          totalDays: {multiDayInfo.totalDays}<br/>
          nights: {nights}
        </div>
      )}
    </div>
  );
};

export default OptionsTab;